import { getCurrentUser } from "aws-amplify/auth";

// Checks if a user is currently logged in using AWS Amplify
// @returns {Promise<boolean>} A promise that resolves to true if the user is logged in, false otherwise
export const isUserLoggedIn = async (): Promise<boolean> => {
    try {
        // If this call succeeds, a user is logged in
        await getCurrentUser();
        return true;
    } catch (error) {
        // If this call fails, no user is currently logged in
        return false;
    }
};
